module.exports = __webpack_public_path__ + "static/media/HCMM328.2a5a3e7c.jpg";